import { translateFn } from '../../../../../../../../utils/translator.helper';
import { DefaultColumnKeys, IColumnType, IDataTableColumn } from '../../../../../../../../ui/gzDataTable/types';
import {
  getAdapterNetworkTypeFormOptionsForGrid,
  getAdapterStealthModeFormOptionsForGrid,
  getAdapterTypeFormGrid,
} from '../../../../../utils/uiSettings/firewall/firewall.values';
import { html, TemplateResult } from 'lit';
import { FirewallNetworkIdentification } from '@nirvana/shared/dtos/types/policies/common';

export enum ColumnKeys {
  TYPE = 'type',
  NETWORK_TYPE = 'networkType',
  STEALTH_MODE = 'stealthMode',
}

export function getTableColumns(): IDataTableColumn[] {
  return [
    {
      key: ColumnKeys.TYPE,
      header: translateFn('Adapter type'),
      columnType: IColumnType.DISPLAY,
      options: getAdapterTypeFormGrid(),
      renderer: typeCellCustomRenderer,
    },
    {
      key: ColumnKeys.NETWORK_TYPE,
      header: translateFn('Network profile'),
      columnType: IColumnType.SINGLE_SELECT,
      options: getAdapterNetworkTypeFormOptionsForGrid(),
    },
    {
      key: ColumnKeys.STEALTH_MODE,
      header: translateFn('Network discovery'),
      columnType: IColumnType.SINGLE_SELECT,
      options: getAdapterStealthModeFormOptionsForGrid(),
    },
    {
      key: DefaultColumnKeys.ACTIONS,
      header: translateFn('Actions'),
      columnType: IColumnType.DISPLAY,
    },
  ];
}

export function typeCellCustomRenderer(
  content: FirewallNetworkIdentification,
  column: IDataTableColumn,
  rowIndex: number
): TemplateResult {
  const displayValue = column.options?.find(item => item.value === content);
  const formattedContent = displayValue ? displayValue.label : content;

  return html`
    <gz-tooltip isEllipsis tooltipText="${formattedContent}" class="cell-label">${formattedContent}</gz-tooltip>
  `;
}
